/**
 * Action Dependencies
 */
import { groupBy } from 'lodash'
import {
    removeLink,
    getProjectLinks,
    updateProjectLink
} from '../../../../services/ProjectService'

/**
 * Get the links generated for a projcect
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const getLinks = ({ commit }) => {
    getProjectLinks()
        .then(res => {
            let grouped = groupBy(res.data, x => x.project_name)
            let links = grouped.map((value, key) => {
                return {
                    project_name: key,
                    links: value.map(project => {
                        project.copied = false
                        return project
                    })
                }
            })
            commit('GET_PROJECT_LINKS_SUCCESS', links)
        })
        .catch(res => commit('GET_PROJECT_LINKS_FAILURE'))
}

/**
 * Modify the project link active status
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const updateProjectLinkStatus = ({ commit, state }, payload) => {
    updateProjectLink(payload.id, payload.active)
        .then(res => {
            state.data.every((item, idx) => {
                let found = item.links.findIndex(link => {
                    return link.id === payload.id
                })
                if (found !== -1) {
                    commit('UPDATE_LINK_STATUS', {
                        parentIndex: idx,
                        childIndex: found,
                        status: payload.active
                    })
                    return false
                }
                return true
            })
        })
        .catch(err => console.log(err))
}

/**
 * Update the search value
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const updateSearchValue = ({ commit }, value) => {
    commit('UPDATE_SEARCH_VALUE', value)
}

/**
 * Remove a shared link
 *
 * @param  {Function} options.commit
 * @param  {Number} id
 * @return {Promise}
 */
const deleteProjectLink = ({ commit }, id) => {
    return removeLink(id)
        .then(res => commit('LINK_REMOVED_SUCCESS', id))
        .catch(err => commit('LINK_REMOVED_FAILURE', err))
}

/**
 * Trigger the state reset
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const resetState = ({ commit }) => {
    commit('RESET_STATE')
}

export default {
    getLinks,
    resetState,
    updateSearchValue,
    deleteProjectLink,
    updateProjectLinkStatus
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/links/actions.js